import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${props => props.fontColor};
  width: 100%;
  height: 100%;
`
export const Value = styled.data`
  font-weight: 700;
  font-size: 150%;
`
export const Label = styled.div`
  font-weight: 600;
  margin-top: -0.25rem;
`